import i18n from "@/common/i18n";
import Layout from '@/layout/index';
const router = [{
  path: '/AI',
  component: Layout,
  redirect: '/AI/chat/list',
  meta: {
    auth: true,
    title: `${i18n.t("lang.k_012001")}`,
    name: 'AI',
    icon: 'saasicon_ai_img',
    level: 1,
    auth_key: 'ai_chat'
  },
  children: [{
    path: 'chat/list',
    component: () => import('@/views/AIModule/chat/list'),
    meta: {
      auth: true,
      title: `${i18n.t("lang.k_012002")}`,
      name: 'AIChatList',
      showOneChildren: true
    }
  }, {
    path: 'chat/create',
    component: () => import('@/views/AIModule/chat/edit'),
    meta: {
      auth: true,
      title: `${i18n.t("lang.k_012003")}`,
      level: 2,
      name: 'AIChatCreate',
      activeMenu: '/AI/chat/list'
    },
    hidden: true
  }, {
    path: 'chat/edit/:id',
    component: () => import('@/views/AIModule/chat/edit'),
    meta: {
      auth: true,
      title: `${i18n.t("lang.k_012004")}`,
      level: 2,
      name: 'AIChatEdit',
      activeMenu: '/AI/chat/list'
    },
    hidden: true
  }]
}];
export default router;